import React from 'react';
import ReactContentLoader from 'react-content-loader';
import useMedia from 'hooks/useMedia';

import {
  TitleBar,
  Title,
  AddCertificateButton,
  EditCertificateButton,
  ControlsContainer,
} from './styles';
import Box from 'components/elements/Box';
import colors from 'styles/themes/colors';
import { rgba } from 'polished';

const CertificationLoader: React.FC = () => {
  const isSmallScreen = useMedia('(max-width: 30em)');

  return (
    <>
      <TitleBar isNotPadded>
        <Title>Certifications</Title>

        <ControlsContainer isMobile={isSmallScreen}>
          <EditCertificateButton isMobile={isSmallScreen} disabled>
            Edit
          </EditCertificateButton>
          <AddCertificateButton isMobile={isSmallScreen} disabled>
            + Add Certification
          </AddCertificateButton>
        </ControlsContainer>
      </TitleBar>

      <Box>
        <ReactContentLoader
          speed={1}
          foregroundColor={colors.Sand}
          backgroundColor={rgba(colors.LightGrey, 0.6)}
          height={130}
        >
          <>
            <rect width="200" height="20" x="0" y="10" />
            <rect width="200" height="20" x="0" y="35" />
            <rect width="200" height="20" x="0" y="60" />
          </>
        </ReactContentLoader>
      </Box>
    </>
  );
};

export default CertificationLoader;
